import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const ProgressChart = ({ data, width, height }) => {
  const _data = {
    labels: data.map((d) => d.name),
    datasets: [
      {
        fill: true,
        label: "Sit to Stand",
        data: data.map((d) => d.value),
        borderColor: "rgb(255, 208, 36)",
        backgroundColor: "rgba(255, 208, 36, 0.3)",
      },
    ],
  };

  const _options = {
    responsive: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Sit to Stand",
      },
    },
  };

  return (
    <Line
      data={_data}
      options={_options}
      style={{ width: `${width}px`, height: `${height}px` }}
    />
  );
};

export default ProgressChart;
